import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const useNavigateBackButton = (route: string) => {
  const navigate = useNavigate();

  useEffect(() => {
    const handlePopState = () => {
      navigate(route);
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      setTimeout(() => {
        window.removeEventListener('popstate', handlePopState);
      }, 0);
    };
  }, [route, navigate]);
};

export default useNavigateBackButton;
